if (document.querySelectorAll(".countdown").length > 0) {
    //document.querySelectorAll(".countdown").forEach(element => {
    //    element.style.visibility = "hidden"; // Example: hide all elements with the class
    //  });
    let textToUpdate = "";
    let interval;
    function startCountdown(endDateTime) {
        document.querySelectorAll(".countdown").forEach(element => {
            element.style.visibility = "visible"; // Example: hide all elements with the class
          });
        const countdownElements = document.querySelectorAll(".countdown");
        if (countdownElements.length === 0) {
            console.error("No elements with the class 'countdown' found in the DOM.");
            return;
        }

        const [year, month, day, hour, minute] = endDateTime.split(",").map(Number);
        const endDate = new Date(year, month - 1, day, hour, minute);

        function updateCountdown() {
            const now = new Date();
            const timeDifference = endDate - now;
            let countdownText;
            if (timeDifference <= 0) {
                countdownText = "00:00:00";
                clearInterval(interval);
            } else {
                const totalSeconds = Math.floor(timeDifference / 1000);
                const totalHours = Math.floor(totalSeconds / 3600);
                const andText = window.translations.counter.and;
                
                // When more than 24 hours left: show days, hours, and minutes
                if (totalHours >= 24) {
                    const days = Math.floor(totalHours / 24);
                    const hours = totalHours % 24;
                    const minutes = Math.floor((totalSeconds % 3600) / 60);
                    
                    const daysText = days === 1 ? window.translations.counter.day : window.translations.counter.days;
                    const hoursText = hours === 1 ? window.translations.counter.hour : window.translations.counter.hours;
                    const minutesText = minutes === 1 ? window.translations.counter.minute : window.translations.counter.minutes;
                    
                    countdownText = `<strong>${days}</strong> ${daysText}, <strong>${hours}</strong> ${hoursText} ${andText} <strong>${minutes}</strong> ${minutesText}`;
                } else {
                    // When less than 24 hours left: show hours, minutes, and seconds
                    const hours = totalHours;
                    const minutes = Math.floor((totalSeconds % 3600) / 60);
                    const seconds = totalSeconds % 60;
                    
                    const hoursText = hours === 1 ? window.translations.counter.hour : window.translations.counter.hours;
                    const minutesText = minutes === 1 ? window.translations.counter.minute : window.translations.counter.minutes;
                    const secondsText = seconds === 1 ? window.translations.counter.second : window.translations.counter.seconds;
                    
                    countdownText = `<strong>${hours}</strong> ${hoursText}, <strong>${minutes}</strong> ${minutesText} ${andText} <strong>${seconds}</strong> ${secondsText}`;
                }
            }

            if (textToUpdate === '') {
                textToUpdate = "$counter";
            }

            countdownElements.forEach(element => {
                const updatedText = element.innerHTML.replace(textToUpdate, countdownText);
                element.innerHTML = updatedText;
            });
            textToUpdate = countdownText;
        }

        updateCountdown();
        interval = setInterval(updateCountdown, 1000);
    }

    window.onload = function() {
        const swiperElement = document.getElementById("swiper");
        startCountdown(swiperElement.dataset.dateto);
    };
}

